import React, { useState } from "react";
import classes from "./ClassCard.module.scss";
import videoType from "../../../assets/images/CardTypeIcons/videoTypeIcon.svg";
import quizType from "../../../assets/images/CardTypeIcons/quiz_icon.svg";
import surveyType from "../../../assets/images/CardTypeIcons/survey_icon.svg";
import youtubeType from "../../../assets/images/CardTypeIcons/youtubeTypeIcon.svg";
import pptType from "../../../assets/images/CardTypeIcons/pptTypeIcon.svg";
import o365Type from "../../../assets/images/CardTypeIcons/office365TypeIcon.svg";
import slideShareType from "../../../assets/images/CardTypeIcons/groupTypeIcon.svg";
import oneDriveType from "../../../assets/images/CardTypeIcons/cloudTypeIcon.svg";
import pdfType from "../../../assets/images/CardTypeIcons/pdfTypeIcon.svg";
import moocType from "../../../assets/images/CardTypeIcons/moocTypeIcon.svg";
import scormType from "../../../assets/images/CardTypeIcons/scromTypeIcon.svg";
import imageType from "../../../assets/images/CardTypeIcons/imageTypeIcon.svg";
import htmlType from "../../../assets/images/CardTypeIcons/htmlTypeIcon.svg";
import noImageFound from "../../../assets/images/CardTypeIcons/noImageFound.png";
import InforIcon from "../SvgIcons/DistributeIcons/InfoIcon";
import Tooltip from "../ToolTip/Tooltip";
import { RiDeleteBin6Line } from "react-icons/ri";
import ClassCardContentModal from "./ClassCardContent/ClassCardContentModal";

const ClassCard = ({
  handleDelete,
  isDeleteVisible,
  isCheckboxVisible,
  isChecked,
  handleCheckboxChange,
  isInfoIconVisible,
  infoText,
  shotClassData,
}) => {
  const [hover, setHover] = useState(false);
  const [contentVideoModal, setContentVideoModal] = useState(false);
  const mediatype = shotClassData?.Mediatype;
  const shotClassType = shotClassData?.ShotClassType;

  const onCardClick = () => {
    if (mediatype === 8 || mediatype === 11) {
      window.open(shotClassData?.VideoUrl, "_blank");
    } else if (mediatype) setContentVideoModal(true);
  };

  return (
    <>
      <div className={classes.cardContainer} key={shotClassData?.ID}>
        <div
          className={classes.cardContainer__main}
          style={{
            cursor: mediatype ? "pointer" : "normal",
          }}
        >
          <div
            className={classes.cardContainer__main__content}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {isDeleteVisible && (
              <div
                className={classes.cardContainer__main__content__delete}
                onClick={handleDelete}
              >
                <div
                  className={classes.cardContainer__main__content__delete__icon}
                >
                  <Tooltip content="Delete" direction="right">
                    <RiDeleteBin6Line size={20} />
                  </Tooltip>
                </div>
              </div>
            )}
            {isCheckboxVisible && (
              <div className={classes.cardContainer__main__content__checkbox}>
                <input
                  className={classes.series}
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
              </div>
            )}
            <img
              src={
                shotClassData?.VideoThumbnailUrl
                  ? shotClassData?.VideoThumbnailUrl
                  : noImageFound
              }
              alt={shotClassData?.Name}
              className={
                hover
                  ? classes.cardContainer__main__content__thumbnailHover
                  : classes.cardContainer__main__content__thumbnail
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImageFound;
              }}
              onClick={onCardClick}
            />
          </div>
        </div>
        <div className={classes.cardContainer__details}>
          <div
            className={classes.cardContainer__details__title}
            title={shotClassData?.Name}
          >
            {shotClassData?.Name}
          </div>
          <div
            className={classes.cardContainer__details__icon}
            title={infoText}
          >
            {isInfoIconVisible && (
              // <Tooltip content={infoText} direction="bottom">
              <InforIcon
                fill={shotClassData?.PublishedbyMe ? "#31C56F" : "#005cc8"}
                stroke={shotClassData?.PublishedbyMe ? "#31C56F" : "#005cc8"}
              />
              // </Tooltip>
            )}
            {mediatype === 1 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={videoType}
                alt="video"
              />
            ) : mediatype === 2 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={youtubeType}
                alt="youtube Video"
              />
            ) : mediatype === 3 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={pptType}
                alt="ppt"
              />
            ) : mediatype === 4 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={o365Type}
                alt="O365"
              />
            ) : mediatype === 5 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={slideShareType}
                alt="slide share"
              />
            ) : mediatype === 6 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={oneDriveType}
                alt="one drive"
              />
            ) : mediatype === 7 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={pdfType}
                alt="pdf"
              />
            ) : mediatype === 8 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={moocType}
                alt="mooc"
              />
            ) : mediatype === 9 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={scormType}
                alt="scrom"
              />
            ) : mediatype === 10 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={imageType}
                alt="img"
              />
            ) : mediatype === 11 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={htmlType}
                alt="html"
              />
            ) : shotClassType === 5 || shotClassType === 6 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={quizType}
                alt="quiz"
              />
            ) : shotClassType === 7 ? (
              <img
                className={classes.classCard__detailsContainer__typeImage}
                loading="lazy"
                src={surveyType}
                alt="survey"
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      {contentVideoModal && (
        <ClassCardContentModal
          mediatype={mediatype}
          contentVideoModal={contentVideoModal}
          setContentVideoModal={setContentVideoModal}
          shotClassData={shotClassData}
        />
      )}
    </>
  );
};

export default ClassCard;
